import { render, staticRenderFns } from "./ReturBon.vue?vue&type=template&id=281929bc&scoped=true"
import script from "./ReturBon.vue?vue&type=script&lang=js"
export * from "./ReturBon.vue?vue&type=script&lang=js"
import style0 from "./ReturBon.vue?vue&type=style&index=0&id=281929bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281929bc",
  null
  
)

export default component.exports